import { render, staticRenderFns } from "./DataSubjects.vue?vue&type=template&id=6dc97d78&"
import script from "./DataSubjects.vue?vue&type=script&lang=js&"
export * from "./DataSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports